module.exports = __webpack_public_path__ + "img/address_preset.22d0ef7c.svg";